import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const JuniorWing = () => {  
  useEffect(() => {
    document.title = 'Junior Wing - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Junior Wing</li>
                </ul>
            </div> 
            <section className="innerbody innerimgdec">
            <div className="container"> 
                    <div className="row"> 
                    <div className="col-lg-12">
                    <p>
                    From the playway informal education system of the Pre-Primary Wing to the initiation into the formal
                    system,
                    the transition is made easy through interactive skill-based teaching and Smart classes. The regular
                    assessment of the skills helps the system of continuous comprehensive evaluation throughout the
                    year,
                    ensuring stress is laid on the holistic development of the students.
                </p>
                     </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/junior_wing_1.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/junior_wing_2.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/junior_wing_3.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
            </div>
                    </div>
                    </div>  
           </section>
           <Footer/>
        </>
    );
}

export default JuniorWing;
